module.exports = __webpack_public_path__ + "static/media/carly-rae-hobbins-zNHOIzjJiyA-unsplash.3d06646e.jpg";